export class ApiError extends Error {
  status: number;
  field?: string;
  retryAfterSeconds?: number;
  readonly balanceGrantOutcome?: "rejected" | "committed";

  constructor(message: string, status: number, field?: string, retryAfterSeconds?: number, balanceGrantOutcome?: "rejected" | "committed") {
    super(message);
    this.status = status;
    this.field = field;
    this.retryAfterSeconds = retryAfterSeconds;
    this.balanceGrantOutcome = balanceGrantOutcome;
  }
}

/** Accept Retry-After seconds or HTTP dates, bounded to one day. */
export function retryAfterSeconds(header: string | null, now = Date.now()): number | undefined {
  if (!header || header.length > 128) return undefined;
  const value = header.trim();
  const seconds = /^\d+$/.test(value) ? Number(value) : (Date.parse(value) - now) / 1000;
  return Number.isFinite(seconds) && seconds >= 0 ? Math.min(86400, Math.ceil(seconds)) : undefined;
}

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    ...init,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
  const payload = await response.json().catch(() => ({}));
  const outcome = response.headers.get("X-Balance-Grant-Outcome");
  if (!response.ok) throw new ApiError(payload.error ?? "请求失败，请稍后重试。", response.status, payload.field, retryAfterSeconds(response.headers.get("Retry-After")), outcome === "rejected" || outcome === "committed" ? outcome : undefined);
  return payload as T;
}
